import { Route, Routes } from "react-router-dom";
import { OAuthAuthorize } from "./OAuthAuthorize";
import { OAuthCallback } from "./OAuthCallback";
import { GoogleSheetsConnectCallback } from "./GoogleSheetsConnectCallback";

export const OAuthPopupRoutes = () => (
    <Routes>
        <Route path="/oauth/authorize/:service" element={<OAuthAuthorize />} />
        <Route
            path="/oauth/callback/google-sheets"
            element={<GoogleSheetsConnectCallback />}
        />
        <Route path="/oauth/callback/:service" element={<OAuthCallback />} />
    </Routes>
);
